<nav
  class="sidebar"
  [class.collapsed]="isCollapsed"
  role="navigation"
  aria-label="Ana menü"
>
  <ul class="menu-list" role="menubar">
    @for (item of menuItems; track item.route) {
    <li class="menu-item" role="none">
      <a
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
        class="menu-link"
        role="menuitem"
        [attr.title]="isCollapsed ? (item.label | translate) : null"
        [attr.aria-label]="item.label | translate"
        (click)="menuItemClick.emit(item)"
      >
        <span class="material-icons icon" aria-hidden="true">{{
          item.icon
        }}</span>
        @if (!isCollapsed) {
        <span class="label">{{ item.label | translate }}</span>
        }
      </a>
    </li>
    }
  </ul>
</nav>
